import { Routes } from '@angular/router';
import { AppLayout } from '@app/layout/component/app.layout';
import { DashboardComponent } from '@app/pages/dashboard/dashboard.component';
import { Notfound } from '@app/pages/notfound/notfound';
import { onlyAuthUserGuard } from '@shared/guards/only-auth-user.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayout,
    canActivateChild: [onlyAuthUserGuard],
    children: [{ path: '', component: DashboardComponent }],
  },
  { path: 'notfound', component: Notfound },
  { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
  { path: '**', redirectTo: '/notfound' },
];
